import {Component, Input, OnInit} from '@angular/core';
import {LayerInfosService} from '../../../../shared/service/layer-infos.service';
import {LayerContainerService} from '../../../../shared/service/layer-container.service';


@Component({
    selector: 'app-layer-definition-expression',
    templateUrl: './layer-definition-expression.component.html',
    styleUrls: ['./layer-definition-expression.component.scss'],
    standalone: false
})
export class LayerDefinitionExpressionComponent implements OnInit {
  @Input() itemFunction: any;
  @Input() esriLayer: any;

  public selectboxLabel: string;
  private _selectedFilterValue: any;
  private _filterAttribute: Array<string>;
  private _isDisabled = false;

  constructor(private _layerInfosService: LayerInfosService,
              private _layerContainerService: LayerContainerService
  ) {
  }

  ngOnInit() {
    this.setUpSelectBoxFilterAttribute();
  }


  public set selectedFilterValue(filterValue: any) {
    this._selectedFilterValue = filterValue;
    this.setDefinitionExperssion(this._selectedFilterValue);
  }


  public get filterAttribute(): Array<string> {
    return this._filterAttribute;
  }

  public get isDisabled(): boolean {
    return this._isDisabled;
  }

  private setUpSelectBoxFilterAttribute() {

    this._filterAttribute = [];
    this._layerInfosService.getLayerInfos(this.esriLayer.layer.url).subscribe((layerInfos) => {
      const FilterField = layerInfos.data.fields.filter(f => f.name === this.itemFunction.filterAttribute)[0];
      this._filterAttribute = FilterField.domain.codedValues;
      this._selectedFilterValue = '';
      this.selectboxLabel = this.itemFunction.title;
    });

  }

  /**
   * @description set definitionExpression on mapLayer or FeatureLayer to filter map
   * @param selectedFilterValue
   */
  private setDefinitionExperssion(selectedFilterValue) {

    const tooltipLayer: __esri.FeatureLayer = this.getToolTipFeatureLayer();

    if (typeof (selectedFilterValue) === 'number') {
      this.esriLayer.layer.definitionExpression = `${this.itemFunction.filterAttribute} = ${selectedFilterValue}`;
      if (tooltipLayer) tooltipLayer.definitionExpression = `${this.itemFunction.filterAttribute} = ${selectedFilterValue}`;
    } else {
      this.esriLayer.layer.definitionExpression = null;
      if (tooltipLayer) tooltipLayer.definitionExpression = null;
    }

  }

  /**
   * @description return tooltip esri FeatureLayer
   */
  private getToolTipFeatureLayer(): __esri.FeatureLayer {
    if (this.esriLayer.layer.toolTip) {
      const tooltipLyr = this._layerContainerService.layerList.filter(f => f.esriLayer.id === this.esriLayer.layer.toolTip.fkLayer)[0];
      return tooltipLyr.esriLayer as __esri.FeatureLayer;
    }
    return;
  }
}
